import { usePDFUrl } from "../hooks/hooks_index.js";
import { Loading } from "./components_index.js";

export function MediaPDF({pdfID, name, className}) {
  const {data: url, isLoading} = usePDFUrl(pdfID);

  if (isLoading || !url) return <Loading/>;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`pdf-box ${className ?? ""}`}
    >
      {/* <div className="pdf-icon"></div> */}
      <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Icon_pdf_file.svg/960px-Icon_pdf_file.svg.png?utm_source=en.wikipedia.org&utm_campaign=imageinfo&utm_content=thumbnail" className="pdf-icon" alt="no-img"></img>
      <div className="pdf-name">{name}</div>
    </a>
  )
}